<template>
  <v-container fill-height fluid grid-list-xl>
   <v-layout flat wrap>

      <v-dialog v-model="confirmationPopup" persistent max-width="290">
        <v-card>
          <v-card-title class="headline">Confirmation</v-card-title>
          <v-card-text>Updated Successfully</v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer><v-btn color="primary" text flat @click="closePopup()">Close</v-btn>
            </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="popup" persistent max-width="290">
        <v-toolbar outlined color="light-green lighten-2" height="40">
          <v-toolbar-title class="body-2">Confirmation</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn rounded icon outlined filled small dark color='white' @click="close()"><v-icon>mdi-close</v-icon></v-btn>
        </v-toolbar>
        <v-card><br>
            <v-card-text>Are you sure want to delete ?</v-card-text>
              <v-card-actions>
                <v-btn small outlined dark color="primary" text @click="close()">Cancel</v-btn>
                  <v-spacer></v-spacer>
                <v-btn small outlined dark color="primary" text @click="deleteConfirmation(id)">Confirm</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="NoeditPopup" max-width="300">
          <v-card>
            <v-card-text class="caption text primary">This Event Reservation cannot be modified as event timeline has passed</v-card-text>
            <v-card-actions>
              <v-btn small outlined color="primary" @click="close()">Ok</v-btn>
            </v-card-actions>
          </v-card>
      </v-dialog>

      <v-dialog v-model="kidPopup" max-width="500px" hide-overlay>
        <v-toolbar outlined color="light-green lighten-2" height="40">
          <v-toolbar-title class="body-2">Family Members</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn rounded icon outlined filled small dark color='white' @click="close()"><v-icon>mdi-close</v-icon></v-btn>
        </v-toolbar>
        <v-form ref="form" v-model="valid" :close-on-content-click="false" :nudge-right="100" offset-y full-width>
          <v-card>
            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>     
                  <v-flex xs12 sm6 md4>
                    <v-autocomplete outlined class="caption mr-2" dense :rules="nameRules" placeholder=" " label="Relation" box v-model="KidsJson.relation" :items="['Spouse','Kid','Parent']"></v-autocomplete>
                  </v-flex>                                        
                  <v-flex xs12 sm6 md4>
                    <v-text-field outlined dense :rules="nameRules" class="caption mr-2" box v-model="KidsJson.firstname" label="First Name" placeholder=" " height="25" ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md4>
                    <v-text-field outlined dense :rules="nameRules" class="caption mr-2" box v-model="KidsJson.lastname" label="Last Name" placeholder=" " height="25" ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md4>
                    <v-text-field outlined dense placeholder=" " class="caption mr-2" label="Age" box v-model="KidsJson.age" ></v-text-field>
                  </v-flex> 
                  <v-flex xs12 sm6 md4>
                    <v-autocomplete outlined dense placeholder=" " class="caption mr-2" label="Gender" box v-model="KidsJson.gender" :items="['Female','Male']"></v-autocomplete>
                  </v-flex> 
                  <v-flex xs12 sm6 md4>
                    <v-text-field outlined dense placeholder=" " class="caption mr-2" label="Mobile" box v-model="KidsJson.mobile" ></v-text-field>
                  </v-flex>                                               
                </v-layout>
              </v-container>
            </v-card-text>
              <v-card-actions>
                <v-btn small outline color="light-green lighten-3 mx-3" @click="clearData()">Clear</v-btn>
                <v-spacer></v-spacer>
                <v-btn  v-if="KidsJson.gender != '' && KidsJson._id === ''  && KidsJson.age!='' && KidsJson.relation!='' && KidsJson.firstname!='' && KidsJson.lastname!=''" small outline color="light-green lighten-2" @click="addFamilyDetails()" :disabled="!valid">Submit</v-btn>
                <v-btn  v-if="KidsJson._id !== '' && KidsJson.insertTimeStamp !== ''" small outline color="light-green lighten-3" @click="update()" :disabled="!valid">Update</v-btn>
              </v-card-actions>
          </v-card>
        </v-form>
      </v-dialog> 
      
      <v-dialog v-model="eventPopup" max-width="500px" hide-overlay>
        <v-toolbar outlined color="light-green lighten-2" height="40">
          <v-toolbar-title class="body-2">Edit MyProgram</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn rounded icon outlined filled small dark color='white' @click="close()"><v-icon>mdi-close</v-icon></v-btn>
        </v-toolbar>
        <v-form ref="form" v-model="valid" :close-on-content-click="false" :nudge-right="100" offset-y full-width>
          <v-card>
            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>     
                  <v-flex xs12 sm6 md6>
                    <v-text-field outlined class="caption mr-2"  background-color="lime lighten-5" dense :rules="nameRules" placeholder=" " label="AdultsCount" box v-model="pJson.adultsCount" readonly></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md6>
                    <v-autocomplete outlined class="caption mr-2" dense :rules="nameRules" placeholder=" " label="Veg Count" box v-model="pJson.VBCount" :items="[0, 1, 2, 3, 4, 5, 6 , 7, 8, 9 ,10]"></v-autocomplete>
                  </v-flex>                                          
                  <v-flex xs12 sm6 md6>
                    <v-autocomplete outlined class="caption mr-2" dense placeholder=" " label="Chicken Biriyani Count" box v-model="pJson.CBCount" :items="[0, 1, 2, 3, 4, 5, 6 , 7, 8, 9 ,10]"></v-autocomplete>
                  </v-flex>
                  <v-flex xs12 sm6 md6>
                    <v-autocomplete outlined class="caption mr-2" dense placeholder=" " label="Goat Biriyani Count" box v-model="pJson.GBCount" :items="[0, 1, 2, 3, 4, 5, 6 , 7, 8, 9 ,10]"></v-autocomplete> 
                  </v-flex>
                  <v-flex xs12 sm12 md12>
                    <v-alert
                    dense
                    icon="mdi-firework"
                    type="primary"
                    theme="dark"
                  >
                    After updating, select Pay Now button and update the below amount to complete payment.
                  </v-alert> 
                    <v-text-field outlined dense placeholder=" "  background-color="lime lighten-5" class="caption mr-2" label="Total Amount to be Paid" box v-model="newTotalAmount" readonly ></v-text-field>
                  </v-flex>            
                </v-layout>
              </v-container>
            </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn  v-if="pJson._id !== ''" small outline color="light-green lighten-3" @click="updateMyProgram()" :disabled="!valid">Update</v-btn>
              </v-card-actions>
          </v-card>
        </v-form>
      </v-dialog>   
      
      <v-flex xs12 md8 class="elevation-0">
          <v-card class="elevation-0 text-center white d-flex flex-column align-center justify-center">
              <strong class="text-h7 blue--text pl-0 mx-3">My Profile</strong>
              <qr-code :text="this.loggedInPerson" :size="100" color="blue" error-level="L"></qr-code><br>
          </v-card>
          <v-form>
            <v-container py-0>
              <v-layout wrap>          
                <v-flex xs12 md3>
                  <v-text-field label="First Name" background-color="indigo lighten-5 " outlined dense v-model="Json.firstname" class="body-2 purple-input" readonly/>
                </v-flex>
                <v-flex xs12 md3>
                  <v-text-field label="Last Name"  background-color="indigo lighten-5 " outlined dense v-model="Json.lastname" class="body-2 purple-input" readonly/>
                </v-flex>
                <v-flex xs12 md2>
                  <v-text-field label="Mobile" outlined dense v-model="Json.mobile" class="body-2 purple-input" />
                </v-flex>
                <v-flex xs12 md4>
                  <v-text-field label="Primary Email" background-color="indigo lighten-5 " v-on:keyup="handleInputOnKeyup" outlined dense v-model="this.loggedInPerson" readonly/>
                </v-flex>
                <v-flex xs12 md2>
                  <v-text-field label="Membership" outlined background-color="indigo lighten-5 " dense v-model="Json.membershipcategory" readonly/>
                </v-flex>
                <v-flex xs12 md2>
                  <v-text-field label="Membership Id" outlined dense background-color="indigo lighten-5 " v-model="Json.membershipId" readonly />
                </v-flex>    
                <v-flex xs12 md3>
                  <v-text-field label="Secondary Email" v-on:keyup="handleInputOnKeyup" outlined dense v-model="Json.secondaryEmail" class="body-2 purple-input" />
                </v-flex>
                <v-flex xs12 md5>
                  <v-text-field label="Address" outlined dense v-model="Json.address" class="body-2 purple-input" />
                </v-flex>
                <v-flex xs12 md2>
                  <v-text-field label="City" outlined dense v-model="Json.city" class="body-2 purple-input" />
                </v-flex>
                <v-flex xs12 md2>
                  <v-select label="State" outlined dense v-model="Json.state" :items="['NC', 'SC']"  class="body-2 purple-input" />
                </v-flex>
                <v-flex xs12 text-xs-center>               
                  <v-btn class="caption font-weight-light" @click=updatePersonalData() small dark color="primary">Update Profile</v-btn>                       
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
      </v-flex>

      <v-flex xs12 md4 class="elevation-0">
        <div class="text-center">
          <v-avatar class="mx-auto d-block" size="50">
            <img :src="require('@/assets/kids1.jpg')">
          </v-avatar>
          <strong class="text-h7 blue--text pl-0 mx-3">Family Members</strong><br><br>
        </div>
        <v-form>
          <v-container py-0>
            <v-layout wrap flat>
              <v-flex xs12 md12>
                <v-form>
                  <v-layout wrap>
                    <v-flex md12>
                      <material-card color="green" title="Simple Table" text="Kids Table">
                        <v-data-table dense v-bind:headers="headers" v-bind:items="familyData" item-key="_id" class="caption elevation-1" :loading="loading" hide-default-footer>
                          <template v-slot:item.Edit="{ item }">
                            <v-avatar size="23" class="blue darken-1 mx-0"><v-icon small dark @click=getFamilyByID(item._id)>edit</v-icon></v-avatar>
                          </template>
                          <!-- <template v-slot:item.Del="{ item }">
                            <v-avatar size="20" class="red darken-1 mx-0"><v-icon small dark @click=deleteFamilyMember(item._id)>delete</v-icon></v-avatar>
                          </template> -->
                        </v-data-table>
                      </material-card>
                    </v-flex>
                    <v-flex xs12 text-xs-center>
                      <v-btn class="caption mx-2 font-weight-light" small @click=addFamily() dark color="primary">Add Family</v-btn>
                    </v-flex>             
                  </v-layout>
                </v-form>
              </v-flex>            
            </v-layout>
          </v-container>
        </v-form>
      </v-flex>

      <v-flex xs12 md8 class="elevation-0">
        <div class="text-center">
          <v-avatar class="mx-auto d-block" size="50">
            <img :src="require('@/assets/payments.png')">
          </v-avatar>
          <strong class="text-h7 blue--text pl-0 mx-3">My Events</strong><br><br>
        </div>
          <v-form>
            <v-container py-0>
              <v-layout wrap flat>
                <v-flex xs12 md12>
                      <v-form>
                        <v-layout wrap>
                          <v-flex md12>
                            <material-card color="green" title="Simple Table" text="Events Table">
                              <v-data-table dense v-bind:headers="eventHeaders" v-bind:items="eventReservation" item-key="_id" class="caption elevation-1" :loading="loading" hide-default-footer :sort-by="['submitedDate']" :sort-desc="[true]">
                                <template v-slot:item.Edit="{ item }">
                                  <v-avatar size="23" class="indigo darken-1 mx-0"><v-icon small dark @click=getMyProgramByID(item._id)>edit</v-icon></v-avatar>
                                </template>
                                <template v-slot:item.eventpayment="{ item }">
                                  <v-chip :color="getColor(item.eventpayment)" label class="caption" small>{{  getPaymentInfo(item.eventpayment) }}</v-chip>
                              </template>
                            </v-data-table>
                          </material-card>
                        </v-flex>
                        <v-flex xs12 text-xs-center>
                          <v-btn class="caption font-weight-light" small @click=goToEventPayment() dark color="primary">Pay Now</v-btn>
                        </v-flex>  
                      </v-layout>
                    </v-form>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
      </v-flex>

      <v-flex xs12 md4 class="elevation-0">
        <div class="text-center">
          <v-avatar class="mx-auto d-block" size="50">
            <img :src="require('@/assets/PaymentHistory.png')">
          </v-avatar>
          <strong class="text-h7 blue--text pl-0 mx-3">My Profile</strong><br><br>
        </div>
        <v-form>
          <v-container py-0>
            <v-layout wrap flat>
              <v-flex xs12 md12>
                    <v-form>
                      <v-layout wrap>
                        <v-flex md12>
                          <v-data-table dense v-bind:headers="paymentHeaders" v-bind:items="paymentData" :sort-by="['year','primaryemail']" :sort-desc="[true, false]" item-key="_id" class="caption elevation-1" :loading="loading" hide-default-footer>
                          </v-data-table>
                        </v-flex>
                        <v-flex xs12 text-xs-center>
                          <v-btn class="caption mx-2 font-weight-light" small @click=goToPayment() dark color="primary">Pay Membership</v-btn>
                        </v-flex>             
                    </v-layout>
                  </v-form>
                </v-flex>            
            </v-layout>
          </v-container>
        </v-form>
      </v-flex>

    </v-layout>
  </v-container>
</template>

<script>
import ReportServices from '@/services/ReportServices'
//import QrcodeVue from 'qrcode.vue'

export default {
  data: () => ({
      value: null,
      size: 100,
      email: undefined,
      form: false,
      isLoading: false,
      loading:false,
      valid: true,
      popup: false,
      profile:false,
      confirmationPopup:false,
      NoeditPopup:false,
      kidPopup: false,
      eventPopup: false,
      loggedInPerson:'',
      kidsList:[],
      kid:[],
      familyData: [],
      eventReservation:[],
      paymentData:[],
      Json:{},
      KidsJson: {
        firstname: '',
        lastname: '',
        relation:'',
        familyId:'',
        mobile:'',
        age:'',
        gender:''
      },
      pJson: {
        primaryemail:'',
        firstname: '',
        lastname: '',
        membershipcategory: '',
        paymentstatus: '',
        year: '',
        checkinstatus:'',
        event:'',
        memberId:'',
        adultsCount:'',
        VBCount: 0,
        CBCount: 0,
        GBCount: 0,
        submitedDate:'',
        comments: '',
        eventpayment: '',
      },
      rules: {
        email: v => (v || '').match(/@/) || 'Please enter a valid email',
        length: len => v => (v || '').length >= len || `Invalid character length, required ${len}`,
        password: v => (v || '').match(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*(_|[^\w])).+$/) || 'Password must contain an upper case letter, a numeric character, and a special character',
        required: v => !!v || 'This field is required',
      },
    headers: [
      {sortable: false,text: 'First Name', value: 'firstname', class: "font-weight-black indigo lighten-5 black--text", divider: true, width: "1%"},
      {sortable: false,text: 'Last Name',value: 'lastname',  class: "font-weight-black indigo lighten-5 black--text", divider: true, width: "1%"},
      {sortable: false, text: 'Relation', value: 'relation',  class: "font-weight-black indigo lighten-5 black--text", divider: true, width: "1%"},
      {sortable: false,text: 'Age',value: 'age',  class: "font-weight-black indigo lighten-5 black--text", divider: true, width: "1%"},
      {sortable: false, text: 'Edit', value: 'Edit',  class: "font-weight-black indigo lighten-5 black--text", divider: true, width: "1%"},
    ],
    eventHeaders: [
      {sortable: false,text: 'Event', value: 'event',  class: "font-weight-black indigo lighten-5 black--text", divider: true, width: "20%"},
      {sortable: false,text: '# Adults',value: 'adultsCount',  class: "font-weight-black indigo lighten-5 black--text", divider: true, width: "5%"},
      {sortable: false,text: '# Kids', value: 'KCount',  class: "font-weight-black indigo lighten-5 black--text", divider: true, width: "5%"},
      {sortable: false,text: '# Parents/Youth',value: 'PCount',  class: "font-weight-black indigo lighten-5 black--text", divider: true, width: "5%"},
      {sortable: false, text: 'Amount', value: 'totalAmount',  class: "font-weight-black indigo lighten-5 black--text", divider: true, width: "5%"},
      {sortable: false, text: 'Status', value: 'eventpayment',  class: "font-weight-black indigo lighten-5 black--text", divider: true, width: "5%"},
      {sortable: false, text: 'Submitted On', value: 'submitedDate',  class: "font-weight-black indigo lighten-5 black--text", divider: true, width: "25%"}
      //{sortable: false, text: 'Edit', value: 'Edit',  class: "font-weight-black indigo lighten-5 black--text", divider: true, width: "1%"}
    ],
    paymentHeaders: [
      {text: 'Membership', align: 'left', value: 'membershipcategory',  class: "font-weight-black indigo lighten-5 black--text", divider: true},
      {text: 'Status', align: 'left', value: 'paymentstatus',  class: "font-weight-black indigo lighten-5 black--text", divider: true, width: "1%"},
      {text: 'Amt', align: 'left', value: 'amount',  class: "font-weight-black indigo lighten-5 black--text", divider: true, width: "1%"},
      {text: 'Year', align: 'left', value: 'year',  class: "font-weight-black indigo lighten-5 black--text", divider: true, width: "1%"},
      {text: 'Pymt Id', align: 'left', value: 'paymentid',  class: "font-weight-black indigo lighten-5 black--text", divider: true, width: "1%"},
    ],
  }),
  computed: {
    newTotalAmount() {
      var toalRows = 0;
      toalRows = this.pJson.adultsCount * 0 + this.pJson.VBCount * 10 + this.pJson.CBCount * 12 + this.pJson.GBCount * 15
      return toalRows;
    },
  },
  // components: {
  //     QrcodeVue,
  // },
  methods: {
    getColor (status) {
      if (status === 'Paid') return 'green'
      else return 'orange'
    },
    getPaymentInfo (eventpayment) {
      if (eventpayment === 'Paid') return 'Paid'
      else return 'Not Paid'
    },
    goToPayment () {   
      this.$router.push('/PaymentGateway')
    },
    goToEventPayment() {
        this.$router.push({ path: "/MemberPayments", replace: true });
      },
    handleInputOnKeyup() {
      this.Json.primaryemail = this.Json.primaryemail.toLowerCase().trim()
    },
    close () {
      //this.profile = false
      //this.kidPopup = false
      //this.popup = false
      this.eventPopup = false
      this.NoeditPopup = false
      setTimeout(() => {
        this.refresh() }, 100)
    },
    async getFamilyByID(id) {
      this.kidPopup = true
      this.CommentInfo = (await ReportServices.getFamilyByID(id)).data
      this.KidsJson= this.CommentInfo
    },
    async getMyProgramByID(id) {
        this.eventInfo = (await ReportServices.getMyProgramByID(id)).data
        this.pJson= this.eventInfo
        if (this.pJson.event === 'NeeyaNaana-202') {
          this.NoeditPopup = true
        } else  {
          this.eventPopup = true
      }
    },
    addFamilyDetails() {
      ReportServices.addFamilyDetails(this.KidsJson)
      setTimeout(() => {
        this.kidPopup = false
        this.refresh()
        }, 200)      
    },
    async clearData() {
      this.KidsJson._id = ''
      this.KidsJson.insertTimeStamp = ''
      this.KidsJson.firstname = '',
      this.KidsJson.lastname= '',
      this.KidsJson.relation= '',
      this.KidsJson.mobile= '',
      this.KidsJson.age= '',
      this.KidsJson.gender= ''
    },
    async closePopup() {
      this.confirmationPopup= false
     },
    async addFamily() {
      this.kidPopup = true
      this.clearData()
    },
    async update () {
      if (this.$refs.form.validate()) {
      await ReportServices.updateFamilyMember(this.KidsJson)
        this.kidPopup = false
        setTimeout(() => {
          this.refresh()
        }, 300)
      }
    },
    updateMyProgram () {
      this.pJson.totalAmount = this.newTotalAmount
      ReportServices.updateMyProgram(this.pJson)
      this.eventPopup = false
      setTimeout(() => {
        this.refresh()
      }, 200)
    },
    async deleteFamilyMember(id) {
      this.id = id
      this.popup = true
    },
    async deleteConfirmation(id) {
      await ReportServices.deleteFamilyMembership(id)
      this.popup = false
      setTimeout(() => {
        this.refresh()
      }, 300)
    },
    async updatePersonalData() {
      this.Json.updateTimeStamp=new Date().toLocaleDateString('en-US', {year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit'})
      await ReportServices.updatemembership(this.Json)
      setTimeout(() => {
        this.confirmationPopup = true
        this.refresh()
      }, 200)
    },
     async refresh () {
      this.loading = true
      this.loggedInPerson = this.$store.getters.email
      this.profileData = (await ReportServices.getmemberbyemail(this.loggedInPerson)).data       
      this.Json= this.profileData
      this.eventReservation = (await ReportServices.getEventReservation(this.loggedInPerson)).data
      this.KidsJson.familyId = this.loggedInPerson
      this.familyData = (await ReportServices.getAllFamilyMembers(this.loggedInPerson)).data
      this.paymentData = (await ReportServices.getPaymentHistory(this.loggedInPerson)).data 
      this.loading = false
      this.noDataText = 'No data available'
    }
  },
  async mounted () {
    this.refresh()
  }
}
</script>

<style scoped>
  * {
    box-sizing: border-box;
    text-transform: none;
  }
  .title {
    color: white;
    background-color: #617997;
    font-size: medium;
  }
</style>